var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        remote: "",
        filterable: "",
        clearable: false,
        placeholder: _vm.placeholder,
        "remote-method": _vm.remoteMethod,
        loading: _vm.loading,
      },
      on: { change: _vm.handleSelectChange },
      model: {
        value: _vm.bindValue,
        callback: function ($$v) {
          _vm.bindValue = $$v
        },
        expression: "bindValue",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.hotPointID,
        attrs: { label: "" + item.name, value: item.hotPointID },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }